import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/self-care-is-for-everyone-shopify-growth-case-study")({
  beforeLoad: () => {
    throw redirect({ to: "/resources/self-care-is-for-everyone-growth-case-study", statusCode: 301 });
  },
});
